import {
  getBookmarks,
  createBookmark,
  deleteBookmark
} from "@utils/aegean_api_handler";

export const GET_BOOKMARKS_REQUEST = "GET_BOOKMARKS_REQUEST";
export const GET_BOOKMARKS_SUCCESS = "GET_BOOKMARKS_SUCCESS";
export const GET_BOOKMARKS_ERROR = "GET_BOOKMARKS_ERROR";
export const ADD_BOOKMARK_REQUEST = "ADD_BOOKMARK_REQUEST";
export const ADD_BOOKMARK_SUCCESS = "ADD_BOOKMARK_SUCCESS";
export const ADD_BOOKMARK_ERROR = "ADD_BOOKMARK_ERROR";
export const REMOVE_BOOKMARK_REQUEST = "REMOVE_BOOKMARK_REQUEST";
export const REMOVE_BOOKMARK_SUCCESS = "REMOVE_BOOKMARK_SUCCESS";
export const REMOVE_BOOKMARK_ERROR = "REMOVE_BOOKMARK_ERROR";

export const fetchBookmarks = () => (dispatch, getState) => {
  const store = getState();

  if (store.bookmarks.isFetching || store.bookmarks.data) {
    // Request for (somewhat) static data - no need for multiple requests
    return Promise.resolve();
  }

  dispatch({ type: GET_BOOKMARKS_REQUEST });

  return getBookmarks()
    .then((result) => {
      dispatch({
        type: GET_BOOKMARKS_SUCCESS,
        data: result
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_BOOKMARKS_ERROR,
        error
      });
    });
};

// @TODO: Once we have user in the store, we can use getState to get it
export const addBookmark = (user_id, table_provider_id) => (dispatch) => {
  dispatch({ type: ADD_BOOKMARK_REQUEST });

  const data = {
    user_id,
    table_provider_id
  };

  return createBookmark(data)
    .then((result) => {
      dispatch({
        type: ADD_BOOKMARK_SUCCESS,
        data: result
      });
    })
    .catch((error) => {
      dispatch({
        type: ADD_BOOKMARK_ERROR,
        error
      });
    });
};

export const removeBookmark = bookmark_id => (dispatch) => {
  dispatch({ type: REMOVE_BOOKMARK_REQUEST });

  return deleteBookmark(bookmark_id)
    .then((result) => {
      dispatch({
        type: REMOVE_BOOKMARK_SUCCESS,
        data: result
      });
    })
    .catch((error) => {
      dispatch({
        type: REMOVE_BOOKMARK_ERROR,
        error
      });
    });
};
